import type { CustomerId, FacilityId } from "./workIds";

export type WorkSearch = {
  externalCustomerId?: CustomerId;
  facilityId?: FacilityId;
};

export function getWorkScopeSearch(
  customer: { id: CustomerId; facilities: { length: number } },
  facility: { id: FacilityId },
): WorkSearch {
  return customer.facilities.length > 1
    ? { externalCustomerId: customer.id, facilityId: facility.id }
    : {};
}
